export default __webpack_public_path__ + "static/media/reviewImage3.e87b7b50.png";